const filteredOwnerTypesList = [
  { label: 'All Owner Types', ownerTypeId: 0 }, // All owner
  { label: 'User Created', ownerTypeId: 9 }, // User
  { label: 'DSP Supplied', ownerTypeId: 5 }, // DSP
  { label: 'Partner Curated', ownerTypeId: 4 }, // Curated
  { label: 'Artist Curated', ownerTypeId: 2 }, // Artist
  { label: 'Chart Playlist', ownerTypeId: 3 }, // Charts
  { label: 'Editorial', ownerTypeId: 6 }, // Editorial
  { label: 'Topsify', ownerTypeId: 8 }, // Topsify
];

export default (ownerTypeIds: number[]): any =>
  filteredOwnerTypesList.filter((type) =>
    ownerTypeIds.some((oTypeId) => oTypeId === type.ownerTypeId)
  );
